import { TranslateService } from '@ngx-translate/core';
import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { Referrals } from './../../models/referrals';
import { Funnel } from '../../models/funnel';
import { stacked_area_chart_ui } from '../../models/analytics';
import { take } from 'rxjs/operators';

@Component({
  selector: 'mj-analytics-details',
  templateUrl: 'analytics-details.component.html',
  styleUrls: ['analytics-details.component.scss'],
})
export class AnalyticsDetailsComponent implements OnChanges {
  @Input() funnel: Funnel;
  @Input() funnelErrors: any[];
  @Input() referrals: Referrals;
  @Input() referralsErrors: any[];

  localReferralsAggregations: any[] = [];
  // TODO
  // if we would like to have timeline feature enabled just use:
  // timeline="true" on chart.

  stacked_area_chart_ui = stacked_area_chart_ui;

  private commonConfig = {
    gradient: false,
    xAxis: true,
    yAxis: true,
    legend: true,
    showXAxisLabel: false,
    showYAxisLabel: false,
    animations: true,
    xAxisLabel: '',
    yAxisLabel: '',
    legentTitle: '',
  };

  public referralsConfig = {
    ...this.commonConfig,
    legendTitle: 'Referrals',
    showYAxisLabel: true,
    yAxisLabel: 'Page Views',
  };

  public funnelConfig = {
    ...this.commonConfig,
    legendTitle: 'Funnel',
    showXAxisLabel: true,
    xAxisLabel: 'Page Views',
  };

  constructor(public _translate: TranslateService) {
    this._translate
      .get('job_analytics_referrals')
      .pipe(take(1))
      .subscribe(txt => {
        this.referralsConfig = {
          ...this.referralsConfig,
          legendTitle: txt,
        };
      });
    this._translate
      .get('job_analytics_funnel')
      .pipe(take(1))
      .subscribe(txt => {
        this.funnelConfig = { ...this.funnelConfig, legendTitle: txt };
      });
    this._translate
      .get('job_analytics_page_views')
      .pipe(take(1))
      .subscribe(txt => {
        this.funnelConfig = { ...this.funnelConfig, xAxisLabel: txt };
        this.referralsConfig = {
          ...this.referralsConfig,
          xAxisLabel: txt,
        };
      });
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.referrals && this.referrals && this.referrals.aggregations) {
      this.localReferralsAggregations = this.referrals.aggregations.map(ag => {
        return {
          ...ag,
          series: ag.series.map(s => {
            return { ...s, name: new Date(s.name) };
          }),
        };
      });
    }
  }

  public stackedAreaXAxisFormatting(val) {
    return new Date(val).toLocaleDateString();
  }

  public formatInts(val: number) {
    return Math.floor(val) !== val ? '' : val;
  }

  public valueFormatting(v: number): string {
    return `${Math.round(v).toLocaleString()}`;
  }

  public onStackedAreaChartSelect($event: any) {}
}
